import React from 'react';
import { Link } from 'react-router-dom';
import './TermsOfService.css';

const TermsOfService = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <header className="terms-header">
          <Link to="/" className="back-link">← Back to World Rosary</Link>
          <h1>Terms of Service</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </header>

        <div className="terms-body">
          <section className="terms-section">
            <h2>Acceptance of Terms</h2>
            <p>
              By accessing and using World Rosary, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>
          </section>

          <section className="terms-section">
            <h2>Description of Service</h2>
            <p>
              World Rosary is a free, anonymous service that provides synchronized rosary prayer sessions. The service allows users to join live prayer sessions or wait for upcoming sessions without requiring registration or personal information.
            </p>
            <ul>
              <li>Live prayer sessions every 30 minutes on the hour and half hour</li>
              <li>Anonymous participation - no accounts or personal data required</li>
              <li>Optional audio playback for prayers</li>
              <li>Real-time count of active participants</li>
              <li>Optional donation functionality through third-party service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>User Responsibilities</h2>
            <p>
              As a user of World Rosary, you agree to:
            </p>
            <ul>
              <li>Use the service respectfully and in accordance with its spiritual purpose</li>
              <li>Not attempt to disrupt or interfere with the service</li>
              <li>Not use the service for any unlawful or inappropriate purposes</li>
              <li>Respect the privacy and anonymity of other users</li>
              <li>Not attempt to collect or harvest any data from the service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>Privacy and Data Collection</h2>
            <p>
              World Rosary is designed to be completely anonymous and private:
            </p>
            <ul>
              <li>No personal information is collected or stored</li>
              <li>No user accounts or registration required</li>
              <li>No cookies or tracking technologies used</li>
              <li>Only anonymous usage statistics are collected for service improvement</li>
            </ul>
            <p>
              For complete details, please review our <Link to="/privacy">Privacy Policy</Link>.
            </p>
          </section>

          <section className="terms-section">
            <h2>Service Availability</h2>
            <p>
              We strive to provide continuous service, but we cannot guarantee:
            </p>
            <ul>
              <li>Uninterrupted access to the service</li>
              <li>Error-free operation</li>
              <li>Compatibility with all devices or browsers</li>
              <li>Specific prayer session timing accuracy</li>
            </ul>
            <p>
              We reserve the right to modify, suspend, or discontinue the service at any time without notice.
            </p>
          </section>

          <section className="terms-section">
            <h2>Third-Party Services</h2>
            <p>
              Our service may integrate with third-party services:
            </p>
            <ul>
              <li><strong>Donorbox</strong> - For optional donations (subject to Donorbox's terms)</li>
              <li><strong>Socket.IO</strong> - For real-time communication (anonymous only)</li>
            </ul>
            <p>
              These services have their own terms of service and privacy policies. We are not responsible for their content or practices.
            </p>
          </section>

          <section className="terms-section">
            <h2>Intellectual Property</h2>
            <p>
              The World Rosary service, including its design, functionality, and content, is owned by GetVocal, Inc. You may not:
            </p>
            <ul>
              <li>Copy, modify, or distribute our service</li>
              <li>Reverse engineer or attempt to extract source code</li>
              <li>Use our service for commercial purposes without permission</li>
              <li>Create derivative works based on our service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>Disclaimer of Warranties</h2>
            <p>
              World Rosary is provided "as is" without any warranties, express or implied. We disclaim all warranties including:
            </p>
            <ul>
              <li>Merchantability and fitness for a particular purpose</li>
              <li>Non-infringement of third-party rights</li>
              <li>Accuracy, reliability, or completeness of the service</li>
              <li>Uninterrupted or error-free operation</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>Limitation of Liability</h2>
            <p>
              In no event shall GetVocal, Inc. be liable for any indirect, incidental, special, consequential, or punitive damages, including but not limited to:
            </p>
            <ul>
              <li>Loss of profits, data, or use</li>
              <li>Business interruption</li>
              <li>Personal injury or property damage</li>
              <li>Any damages arising from use of the service</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless GetVocal, Inc. from any claims, damages, or expenses arising from your use of the service or violation of these terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>Modifications to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Changes will be posted on this page with an updated "Last updated" date. Continued use of the service after changes constitutes acceptance of the new terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>Termination</h2>
            <p>
              We may terminate or suspend access to our service immediately, without prior notice, for any reason, including violation of these terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>Governing Law</h2>
            <p>
              These terms shall be governed by and construed in accordance with the laws of the United States, without regard to conflict of law principles.
            </p>
          </section>

          <section className="terms-section">
            <h2>Contact Information</h2>
            <p>
              If you have any questions about these terms, please contact us at:
            </p>
            <p>
              <strong>GetVocal, Inc.</strong><br />
              Email: legal@getvocal.com<br />
              Website: <a href="https://getvocal.com" target="_blank" rel="noopener noreferrer">getvocal.com</a>
            </p>
          </section>

          <section className="terms-section">
            <h2>Our Mission</h2>
            <p>
              World Rosary is a free service provided by <strong>GetVocal, Inc.</strong> with the goal of creating world peace through prayer of the rosary. We believe in providing a safe, anonymous, and respectful environment for spiritual connection and prayer.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
